var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 342,
    viewBox: "0 0 358 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.9673 17.2021C81.6725 43.8377 67.4491 57.581 38.5473 68.1371C33.9604 69.8125 33.7975 76.6967 38.3098 78.5637C68.0973 90.8885 82.2195 105.01 92.059 130.446C93.871 135.13 101.194 135.147 103 130.46C113.328 103.66 127.301 89.7461 154.547 78.7066C159.165 76.8353 159.006 69.6643 154.318 67.975C126.906 58.097 113.066 44.4467 102.891 17.2494C101.126 12.5333 93.7826 12.5052 91.9673 17.2021Z",
    fill: "#0060E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8033 228.656C50.9661 250.461 38.7591 262.18 15.0228 271.177C10.4566 272.908 10.2822 279.826 14.7747 281.74C39.2506 292.168 51.4074 304.195 59.8875 325.045C61.7797 329.697 69.1632 329.725 71.0406 325.067C79.868 303.165 91.7964 291.294 114.08 281.91C118.673 279.977 118.515 272.753 113.853 270.995C91.4497 262.547 79.6308 250.903 70.932 228.7C69.0952 224.011 61.6946 223.989 59.8033 228.656Z",
    fill: "#0060E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.571 92.8077C215.392 146.281 190.618 170.718 133.125 189.705C128.488 191.236 128.315 198.011 132.877 199.755C192.103 222.388 216.476 247.598 233.677 298.524C235.284 303.282 242.422 303.294 244.044 298.54C262.472 244.509 287.172 219.86 341.944 199.844C346.624 198.133 346.468 191.108 341.72 189.596C286.503 172.003 262.081 147.819 243.933 92.8521C242.354 88.0705 235.192 88.0402 233.571 92.8077Z",
    fill: "#488FF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.ae3de2e4003ec1c094dbcbe761c94d82.svg";
export { ForwardRef as ReactComponent };